import type { EventVenue } from '@shady-pines/db';
import { GET_VENUES } from './queries';
import { useAutoPaginatedQuery } from './use-paginated-query';

export const useVenues = () => {
  const { items, loading, error } = useAutoPaginatedQuery<
    EventVenue,
    { first?: number; after?: string | null },
    'event_venuesCollection'
  >(GET_VENUES, {}, 'event_venuesCollection');

  return { venues: items, loading, error };
};
